export  const Backgrounds = {
    blueRadial: 'radial-gradient(66.9% 82.39% at 23.93% 33.1%, #243B55 0%, #0B1B2E 100%);',
    button:'#ffb797',
    buttonHover:'#ff958b',
    table: '#F8F4EE',
    header:'#182B43',
    footer: '#08182B',
    form:'#243B55'

};

export const Borders = {
    orange: 'linear-gradient(157.81deg, #FF7147 14.49%, rgba(255, 113, 71, 0.17) 93.93%);',
    blue: 'linear-gradient(152.01deg, #4463E0 17.35%, rgba(98, 89, 89, 0) 155.07%);',
    grey:'linear-gradient(212.2deg, #625959 19.32%, rgba(98, 89, 89, 0) 90.56%);',
    reverseGrey:'linear-gradient(105.42deg, #898585 24.86%, rgba(98, 89, 89, 0) 112.22%)',
    solidGrey: '#625959',
    solidOrange: '#FF7147',
    lightGrey:'#D8D0D0'
};

export const FontSize= {
    title: '30px',
    headersAndButtons: '25px',
    biggerText:'18px',
    text: '13px',
    smallText: '11px'
};

export const FontWeights ={
    regular: '400',
    medium: '500'
};

export const FontsFamilies ={
    logo: "'Orbitron', sans-serif;", //will be removed
    rest: "'Montserrat', sans-serif;"
};

export const FontColors = {
    white:'#FFFFFF',
    lightGrey:'#D8D0D0',
    grey:'#9C9797',
    orange:'#FF7147'
};



